import { base } from '../base';

export const customField = `${base}/CustomField`;
